export const RUSH_RULES_YOUTUBE_ID = '5o74c-8BJ8o';
export const RUSH_RULES_YOUTUBE_EMBED_URL = `https://www.youtube.com/embed/${RUSH_RULES_YOUTUBE_ID}`;
export const RUSH_RULES_YOUTUBE_VIDEO_URL = `https://www.youtube.com/shorts/${RUSH_RULES_YOUTUBE_ID}`;
